import React, { useEffect, useRef, useState } from "react";
import { Carousel, Checkbox, Divider, Form, Input, Link, Message, Modal, Spin } from "@arco-design/web-react";
import userStore from "@/stores/user";
import teamStore from "@/stores/team";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import { SecureStringGenerator } from "@/utils/tool";
import http from "@/utils/http";
import { observer } from "mobx-react";
import { send_code } from "@/services/login";
import { accountLogin, resetPassword, smsLogin } from "@/services/user";
import { setTokenToLocalStorage } from "@/utils/token";
import "./index.less";

import LogoIcon from "@/assets/images/factory-logo.png";
import banner1 from "./images/banner1.png";
import banner2 from "./images/banner2.png";
import banner3 from "./images/banner3.png";
import banner4 from "./images/banner4.png";

const FormItem = Form.Item;

const HomeLogin: React.FC = () => {
  const [form] = Form.useForm();
  // 参数
  const bannerItems = [
    { key: "1", bgColor: "#FFEDED", cover: banner1, text: "定制你的专属AI人物角色" },
    { key: "2", bgColor: "#F1EBFF", cover: banner2, text: "多场景、自动化创作视频" },
    { key: "4", bgColor: "#EEF3FF", cover: banner4, text: "自研视频引擎，更可控、更清晰" },
    { key: "3", bgColor: "#FFF2F0", cover: banner3, text: "自动矩阵发布、全网营销曝光" },
  ];
  // formKey 登录表单类型
  const tabItems = [
    { key: "password", title: "密码登录" },
    { key: "sms", title: "短信登录" },
  ];
  const [formKey, setFormKey] = useState<string>("password"); // 登录表单类型
  const [activeIndex, setActiveIndex] = useState<number>(0); // 登录表单类型索引
  const [loading, setLoading] = useState<boolean>(false); // 登录loading
  const [codeTimer, setCodeTimer] = useState<number>(0); // 验证码倒计时
  const timerRef = useRef<NodeJS.Timeout>(null); // 验证码倒计时定时器
  const captchaRef = useRef<any>(null); // 验证码实例
  const [vertifyVisible, setVertifyVisible] = useState<boolean>(false); // 验证码弹窗是否显示
  const [verifyLoading, setVerifyLoading] = useState<boolean>(false); // 验证码弹窗loading、
  const [loginVisible, setLoginVisible] = useState<boolean>(false); // 登录弹窗是否显示
  const [downCount, setDownCount] = useState<number>(5); // 登录弹窗倒计时
  const downTimerRef = useRef<NodeJS.Timeout>(null); // 登录弹窗倒计时引用
  const [bannerIndex, setBannerIndex] = useState<number>(0); // banner索引
  const [checkdata, setCheckdata] = useState<boolean>(false); // 登录即代表同意

  // 方法
  const commEvent = {
    // 轮播图切换
    changeBanner: (type: "left" | "right") => {
      if (type === "left") {
        setBannerIndex((prevIndex) => (prevIndex - 1 + bannerItems.length) % bannerItems.length);
      } else {
        setBannerIndex((prevIndex) => (prevIndex + 1) % bannerItems.length);
      }
    },
    // 设置登录数据到cookie
    setCookieData: () => {
      const checkdata = form.getFieldValue("rememberPassword");
      if (checkdata) {
        const phone_number = form.getFieldValue("phone_number");
        const password = form.getFieldValue("password");
        const data = {
          phone_number: phone_number,
          password: password,
        };
        Cookies.set(
          "Logindata",
          CryptoJS.AES.encrypt(JSON.stringify(data), SecureStringGenerator.generate(16)).toString(),
          {
            expires: 7,
          },
        );
      } else {
        Cookies.remove("Logindata");
      }
    },
    // 加载登录数据
    loadCookieData: () => {
      if (Cookies.get("Logindata")) {
        const encryptedData = Cookies.get("Logindata");
        try {
          // 解密数据
          const bytes = CryptoJS.AES.decrypt(encryptedData, SecureStringGenerator.generate(16));
          // 将解密后的字节转换为 UTF-8 字符串
          const decrypted = bytes.toString(CryptoJS.enc.Utf8);
          // 检查解密后的数据是否是有效的 UTF-8 字符串
          if (decrypted) {
            try {
              // 解析解密后的 JSON 字符串
              const data = JSON.parse(decrypted);
              const { phone_number, password } = data;
              // 设置表单字段值
              form.setFieldsValue({
                phone_number,
                password,
                rememberPassword: true,
              });
            } catch (error) {
              console.error("解析解密后的数据时出错:", error);
            }
          } else {
            console.error("解密后的数据不是有效的 UTF-8 字符串。");
          }
        } catch (error) {
          console.error("解密数据时出错:", error);
        }
      }
    },
    // 加载验证码
    loadVerifyCaptcha: () => {
      if (!vertifyVisible) return;
      setTimeout(() => {
        if (captchaRef.current) {
          captchaRef.current.reset();
          return;
        }
        captchaRef.current = window.sliderCaptcha(
          {
            id: "home-login-captcha",
            width: 340,
            height: 200,
            sliderL: 42,
            sliderR: 9,
            offset: 8, // 验证容错偏差值
            loadingText: "正在加载中...",
            failedText: "再试一次",
            barText: "向右滑动填充拼图",
            // repeatIcon: "fa fa-repeat",
            setSrc: function () {
              return `https://zhaixing-dev-00.oss-cn-shanghai.aliyuncs.com/public/login/${Math.floor(Math.random() * 5) + 1}.jpg`;
            },
            remoteUrl: "/api/v1/user/verify",
            onImgLoading() {
              console.log("image Loading");
              setVerifyLoading(true);
            },
            onImgLoaded() {
              console.log("image Loaded");
              setVerifyLoading(false);
            },
            verify: async (arr, url) => {
              const data = await http.post(url, { datas: arr });
              return data.data.success;
            },
            onSuccess: async function () {
              //成功事件
              await commEvent.onGetCode();
              setTimeout(() => {
                setVertifyVisible(false);
              }, 1500);
            },
          },
          40,
        );
      });
    },
    // 修改登录表单类型
    changeTab: (key: string) => {
      form.resetFields();
      setFormKey(key);
      if (key === "fargetPassword") return;
      setActiveIndex(tabItems.findIndex((item) => item.key === key));
      if (key === "password") {
        commEvent.loadCookieData();
      }
    },
    //获取验证码
    onGetCode: async () => {
      try {
        const { phone_number } = await form.validate(["phone_number"]);
        await send_code({ phone_number, method: "register", country_code: "+86" });
        const last_phnumber = phone_number.slice(-4);
        Message.success(`验证码短信已经发送至手机尾号${last_phnumber}，请查收`);
        setCodeTimer(60);
        timerRef.current = setInterval(() => {
          setCodeTimer((prev) => {
            if (prev <= 1) {
              clearInterval(timerRef.current);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      } catch (error) {
        Message.info(error);
      }
    },
    // 密码登录
    onPasswordLogin: async (formValue: any) => {
      const { phone_number, password } = formValue;
      setLoading(true);
      const res = await accountLogin({ phone_number, password }).finally(() => setLoading(false));
      if (res.data?.code === 0) {
        const { token = "" } = res.data?.data || {};
        setTokenToLocalStorage(token);
        userStore.setIsLogin(true);
        teamStore.getTeamInfo();
        userStore.getUserInfo();
      }
    },
    // 短信登录
    onSmsLogin: async (formValue: any) => {
      setLoading(true);
      const { phone_number, code } = formValue;
      const res = await smsLogin({ phone_number, verify_code: code }).finally(() => setLoading(false));
      if (res.data?.code === 0) {
        const { token = "" } = res.data?.data || {};
        setTokenToLocalStorage(token);
        userStore.setIsLogin(true);
        teamStore.getTeamInfo();
        userStore.getUserInfo();
      }

      // await loginStore.smslong_login_sms(formValue);
      setLoading(false);
      commEvent.setCookieData();
    },
    // 密码强度校验
    passwordStrength: () => {
      const password = form.getFieldValue("password");
      let strength = -1;
      if (password && password.length > 5) {
        if (/[0-9]/.test(password)) strength += 1;
        if (password.length >= 8) {
          if (/[a-z]/.test(password)) strength += 1;
          if (/[A-Z]/.test(password)) strength += 1;
          if (/\W/.test(password)) strength += 1;
        }
      }
      const level = Math.min(strength, 3);
      let levelop;
      if (level == -1 || level == 0) {
        levelop = 1;
      } else {
        levelop = level;
      }
      const color = ["red", "#FFA5A5", "#faad14", "#A7CBFF", "#A7CBFF"][levelop];
      const numbers = Array.from({ length: levelop }, (_, index) => index);
      return { color, nub: level, numbers: numbers };
    },
    // 忘记密码注册
    onFargetPasswordLogin: async (formValue: any) => {
      const _passwordObj = commEvent.passwordStrength();
      const _data = {
        phone_number: formValue.phone_number,
        verify_code: formValue.code,
        new_password: formValue.password,
        repeat_password: formValue.popp,
        password_strength: _passwordObj.nub == 0 ? 1 : _passwordObj.nub,
      };
      const res = await resetPassword(_data);
      if (res.data?.code === 0) {
        Message.success("密码重置成功");
        setLoginVisible(true);
      }
    },
    // 登录
    onLogin: async () => {
      try {
        const _value = await form.validate();
        if (formKey === "password") {
          if (!checkdata) {
            Message.warning("请勾选用户协议");
            return;
          }
          commEvent.onPasswordLogin(_value);
        } else if (formKey === "sms") {
          if (!checkdata) {
            Message.warning("请勾选用户协议");
            return;
          }
          commEvent.onSmsLogin(_value);
        } else if (formKey === "fargetPassword") {
          commEvent.onFargetPasswordLogin(_value);
        }
      } catch (_) {}
    },
  };

  // 渲染登录表单
  const renderForm = (): React.ReactNode => {
    switch (formKey) {
      case "password":
        return (
          <>
            <FormItem
              className="form_item"
              field="phone_number"
              validateTrigger="onBlur"
              rules={[{ required: true, message: "请输入账号" }]}
            >
              <Input placeholder="请输入账号" className="form_inputs" />
            </FormItem>
            <FormItem
              className="form_item"
              field="password"
              validateTrigger="onBlur"
              rules={[
                { required: true, message: "请输入密码" },
                {
                  match: /^.{6,12}$/,
                  message: "请输入6-12个字符，支持数字、大小写字母和符号至少包含一种",
                },
              ]}
            >
              <Input.Password placeholder="请输入密码" className="form_inputs" />
            </FormItem>
            <div className="form_password">
              <div className="form_password_checkbox">
                <FormItem field="rememberPassword" triggerPropName="checked" noStyle>
                  <Checkbox>
                    <span>记住密码</span>
                  </Checkbox>
                </FormItem>
              </div>
              <Link onClick={() => commEvent.changeTab("fargetPassword")}>忘记密码？</Link>
            </div>
          </>
        );
      case "sms":
        return (
          <>
            <FormItem
              className="form_item"
              field="phone_number"
              validateTrigger="onBlur"
              rules={[
                { required: true, message: "请输入手机号" },
                {
                  match: /^1[3456789]\d{9}$/,
                  message: "请输入正确的手机号",
                },
              ]}
            >
              <Input placeholder="请输入手机号" className="form_inputs" maxLength={11} />
            </FormItem>
            <div className="form_tip">短信登录手机账号,未注册用户将自动创建账号</div>
            <div className="form_code">
              <FormItem
                className="form_item"
                field="code"
                validateTrigger="onBlur"
                rules={[{ required: true, message: "请输入验证码" }]}
              >
                <Input
                  placeholder="请输入验证码"
                  className="form_inputs"
                  maxLength={6}
                  suffix={
                    <div className="code_number_btn">
                      <div className="code_line" />
                      <div
                        className="code_text"
                        onClick={async () => {
                          try {
                            if (codeTimer > 0) return;
                            await form.validate(["phone_number"]);
                            setVertifyVisible(true);
                          } catch (_) {}
                        }}
                      >
                        {codeTimer <= 0 ? "获取验证码" : `${codeTimer}秒后重发`}
                      </div>
                    </div>
                  }
                />
              </FormItem>
            </div>
          </>
        );
      case "fargetPassword":
        return (
          <>
            <FormItem
              className="form_item form_item_farget"
              field="phone_number"
              validateTrigger="onBlur"
              rules={[
                { required: true, message: "请输入手机号" },
                {
                  match: /^1[3456789]\d{9}$/,
                  message: "请输入正确的手机号",
                },
              ]}
            >
              <Input placeholder="请输入手机号" className="form_inputs" maxLength={11} />
            </FormItem>
            <div className="form_code">
              <FormItem
                className="form_item form_item_farget"
                field="code"
                validateTrigger="onBlur"
                rules={[{ required: true, message: "请输入验证码" }]}
              >
                <Input
                  placeholder="请输入验证码"
                  className="form_inputs"
                  maxLength={6}
                  suffix={
                    <div className="code_number_btn">
                      <div className="code_line" />
                      <div
                        className="code_text"
                        onClick={async () => {
                          try {
                            if (codeTimer > 0) return;
                            await form.validate(["phone_number"]);
                            setVertifyVisible(true);
                          } catch (_) {}
                        }}
                      >
                        {codeTimer <= 0 ? "获取验证码" : `${codeTimer}秒后重发`}
                      </div>
                    </div>
                  }
                />
              </FormItem>
            </div>
            <FormItem
              className="form_item form_item_farget"
              field="new_password"
              validateTrigger="onBlur"
              rules={[
                { required: true, message: "请输入密码" },
                {
                  match: /^.{6,12}$/,
                  message: "请输入6-12个字符，支持数字、大小写字母和符号至少包含一种",
                },
              ]}
            >
              <Input.Password placeholder="设置密码" className="form_inputs" />
            </FormItem>
            <div className="form_tip">6-12个字符，支持数字、大小写字母和符号至少包含一种</div>
            <FormItem
              className="form_item form_item_farget"
              field="repeat_password"
              validateTrigger="onBlur"
              rules={[
                { required: true, message: "请输入密码" },
                {
                  validator: (value, callback) => {
                    const password = form.getFieldValue("new_password");
                    if (value !== password) {
                      callback("两次输入密码不一致");
                    } else {
                      callback();
                    }
                  },
                },
              ]}
            >
              <Input.Password placeholder="再次输入密码" className="form_inputs" />
            </FormItem>
          </>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    commEvent.loadCookieData();
    return () => {
      if (timerRef?.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    commEvent.loadVerifyCaptcha();
  }, [vertifyVisible]);

  useEffect(() => {
    if (loginVisible) {
      setDownCount(5);
      downTimerRef.current = setInterval(() => {
        setDownCount((prev) => {
          if (prev <= 1) {
            commEvent.changeTab("password");
            setLoginVisible(false);
            clearInterval(downTimerRef.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      if (timerRef.current) {
        clearInterval(downTimerRef.current);
      }
    }
  }, [loginVisible]);

  useEffect(() => {
    if (userStore.isLogin) {
      setCheckdata(false);
    }
  }, [userStore.isLogin]);

  if (!!userStore?.userInfo?.id || userStore.isLogin) {
    return null;
  }

  return (
    <Spin loading={loading}>
      <div className="home-login-box" onClick={() => userStore.setIsLogin(true)}>
        <div className="login_content" onClick={(e) => e.stopPropagation()}>
          <div className="login_content_show" style={{ backgroundColor: bannerItems[bannerIndex].bgColor }}>
            <img src={LogoIcon} className="show_logo" />
            <div className="show_banner" style={{ backgroundColor: bannerItems[bannerIndex].bgColor }}>
              <Carousel
                autoPlay={{ interval: 3000 }}
                indicatorType="never"
                showArrow="hover"
                onChange={(index) => setBannerIndex(index)}
              >
                {bannerItems.map((item) => (
                  <div key={item.key} className="show_banner_list" style={{ backgroundColor: item.bgColor }}>
                    <img src={item.cover} alt="" />
                    <div className="show_banner_text">{item.text}</div>
                  </div>
                ))}
              </Carousel>
              <div className="show_banner_line">
                {Array.from({ length: 4 }).map((_, index) => (
                  <div
                    className={`banner_line_item ${bannerIndex === index ? "active" : ""}`}
                    key={index}
                    onClick={() => setBannerIndex(index)}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="login_content_form">
            {formKey === "fargetPassword" ? (
              <div className="form_title">找回密码</div>
            ) : (
              <div className="form_tabs">
                {tabItems.map((item) => (
                  <div
                    className={`tab_item ${formKey === item.key ? "active" : ""}`}
                    key={item.key}
                    onClick={() => commEvent.changeTab(item.key)}
                  >
                    {item.title}
                  </div>
                ))}
                <div className="tab_line" style={{ left: activeIndex * 146 }}>
                  <div className="line_box" />
                </div>
              </div>
            )}
            <Form form={form} autoComplete="off" wrapperCol={{ span: 24 }}>
              {renderForm()}
              <FormItem shouldUpdate>
                {(values) => {
                  const { phone_number, password, code, repeat_password, new_password } = values;
                  let _bol = false;
                  if (formKey === "password") {
                    _bol = phone_number && password;
                  } else if (formKey === "sms") {
                    _bol = phone_number && code;
                  } else if (formKey === "fargetPassword") {
                    _bol = phone_number && code && new_password && repeat_password;
                  }
                  return (
                    <div className={`form_login_btn ${!_bol ? "disabled" : ""}`} onClick={commEvent.onLogin}>
                      {formKey === "fargetPassword" ? "提交" : "登录"}
                    </div>
                  );
                }}
              </FormItem>
              {formKey === "fargetPassword" ? (
                <Divider orientation="center" className="form_divider">
                  <span onClick={() => commEvent.changeTab("password")}>返回登录</span>
                </Divider>
              ) : (
                <div className="form_text">
                  <Checkbox className="form_checkbox" checked={checkdata} onChange={() => setCheckdata(!checkdata)} />
                  登录即代表同意
                  <span onClick={() => window.open("/agreement/user")}>《用户协议》</span>和
                  <span onClick={() => window.open("/agreement/privacy")}>《隐私政策》</span>
                </div>
              )}
            </Form>
          </div>
        </div>
      </div>
      <Modal
        title="请完成下列验证后继续"
        style={{ width: 400, height: 340, right: "-25%" }}
        visible={vertifyVisible}
        footer={null}
        onOk={() => setVertifyVisible(false)}
        onCancel={() => setVertifyVisible(false)}
        autoFocus={false}
        focusLock={true}
      >
        <Spin loading={verifyLoading} tip="加载中..." size={24} style={{ position: "absolute", width: "100%" }}>
          <div style={{ marginLeft: -3 }}>
            <div id="home-login-captcha"></div>
          </div>
        </Spin>
      </Modal>
      <Modal
        title="密码重置成功"
        visible={loginVisible}
        style={{ width: 350 }}
        onCancel={() => setLoginVisible(false)}
        footer={null}
      >
        <div className="home-login_reset_content">
          {downCount}秒后 <Link onClick={() => commEvent.changeTab("password")}>返回登录</Link>
        </div>
      </Modal>
    </Spin>
  );
};
export default observer(HomeLogin);
